export default __webpack_public_path__ + "static/media/logout.8ccef340.svg";